import { createLightTheme, createDarkTheme, BrandVariants } from '@fluentui/react-components';

/**
 * DWx brand colors based on Microsoft Fluent Design
 */
const dwxBrand: BrandVariants = {
  10: '#001d3d',
  20: '#002952',
  30: '#003566',
  40: '#00417b',
  50: '#004d90',
  60: '#0059a5',
  70: '#0065ba',
  80: '#0078d4', // Primary brand color
  90: '#1a86d9',
  100: '#3394de',
  110: '#4da2e3',
  120: '#66b0e8',
  130: '#80beed',
  140: '#99ccf2',
  150: '#b3daf7',
  160: '#cce8fc',
};

/**
 * Light theme for the application
 */
export const dwxLightTheme = {
  ...createLightTheme(dwxBrand),
};

/**
 * Dark theme for the application
 */
export const dwxDarkTheme = {
  ...createDarkTheme(dwxBrand),
};

/**
 * Custom tokens for the application
 */
export const customTokens = {
  sidebarWidth: '256px',
  headerHeight: '64px',
  contentPadding: '24px',
  cardBorderRadius: '8px',
} as const;

/**
 * Status colors for deployment states
 */
export const statusColors = {
  success: '#107c10',
  warning: '#ffb900',
  error: '#d13438',
  info: '#0078d4',
  pending: '#605e5c',
  inProgress: '#00bcf2',
} as const;

/**
 * Get color for tenant status
 */
export function getTenantStatusColor(status: string): string {
  const colors: Record<string, string> = {
    Active: statusColors.success,
    Inactive: statusColors.pending,
    Trial: statusColors.warning,
    Suspended: statusColors.error,
    Pending: statusColors.inProgress,
  };
  return colors[status] || statusColors.pending;
}

/**
 * Get color for deployment status
 */
export function getDeploymentStatusColor(status: string): string {
  const colors: Record<string, string> = {
    Success: statusColors.success,
    Failed: statusColors.error,
    InProgress: statusColors.inProgress,
    Pending: statusColors.pending,
    RolledBack: statusColors.warning,
    Cancelled: statusColors.pending,
  };
  return colors[status] || statusColors.pending;
}

/**
 * Get color for step status
 */
export function getStepStatusColor(status: string): string {
  const colors: Record<string, string> = {
    Success: statusColors.success,
    Failed: statusColors.error,
    InProgress: statusColors.inProgress,
    Pending: statusColors.pending,
    Skipped: statusColors.warning,
  };
  return colors[status] || statusColors.pending;
}

/**
 * Get color for alert severity
 */
export function getAlertSeverityColor(severity: string): string {
  const colors: Record<string, string> = {
    Info: statusColors.info,
    Warning: statusColors.warning,
    Error: statusColors.error,
    Critical: statusColors.error,
  };
  return colors[severity] || statusColors.info;
}
